<template>
    <div id="upsellFooter" class="options-footer upsell-footer full-height-footer" ref="upsellFooter">
        <transition name="footer-header-transition">
            <div class="footer-header" v-show="shouldShowHeader">
                <h3>{{ resources.heading }}</h3>
            </div>
        </transition>

        <upsell-page
            :isDesktop="isDesktop"
            :isMobile="isMobile">
        </upsell-page>

        <div class="button-row single-button">
            <button class="btn" :disabled=shouldShowStatusBar @click="handleFinish()">{{ resources.finishedCta }}</button>
        </div>
    </div>
</template>

<script src='./upsell-footer.js'></script>

